// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorData from "./ErrorData.bs.js";
import * as OrderData from "./OrderData.bs.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

function editScheduleDeliveryResponse(json) {
  return {
          giftStatusLabel: OrderData.giftStatusLabelFun(Json_decode.field("gift_status_label", Json_decode.string, json)),
          giftFailedDelivery: OrderData.giftFailedDeliveryFun(Json_decode.field("gift_failed_delivery", (function (param) {
                      return Json_decode.array(Json_decode.string, param);
                    }), json)),
          scheduledDeliveryAt: Json_decode.optional((function (param) {
                  return Json_decode.field("scheduled_delivery_at", Json_decode.string, param);
                }), json)
        };
}

function safeDecodeResendResponse(json) {
  var value;
  try {
    value = editScheduleDeliveryResponse(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return ErrorData.Decode.safeDecodeError(json);
    }
    throw exn;
  }
  return {
          TAG: /* Ok */0,
          _0: value
        };
}

var Decode = {
  editScheduleDeliveryResponse: editScheduleDeliveryResponse,
  safeDecodeResendResponse: safeDecodeResendResponse
};

export {
  Decode ,
}
/* No side effect */
